import config from './config.js'

export default {

  list: function(ctrl,type,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/data/extrafields?type=' + type,'Zusatzfelder laden',cb_success);
  },

  save: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/data/extrafields/' + encodeURIComponent(data.map_id),'Zusatzfeld speichern',JSON.stringify(data),cb_success);
  },

  delete: function(ctrl,mapid,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/data/extrafields/' + encodeURIComponent(mapid),'Zusatzfeld löschen.',cb_success);
  }

}
